import React from 'react';
import { RouteObject } from 'react-router-dom';

import MapGridLayout from 'ff/debrief/layouts/MapGridLayout';
import MapControls from 'ff/debrief/components/map/MapControls';
import FlightDetails from 'ff/debrief/components/details';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import SharedSidebar from 'ff/debrief/components/sidebar/SharedSidebar';

const pathString = '/shared/:tracklogId?';

const HomeRoute = () => {
    return (
        <MapGridLayout>
            <MapControls />
            <SharedSidebar />
            <FlightDetails />
            <ErrorBar />
        </MapGridLayout>
    );
};

const route: RouteObject = {
    path: pathString,
    element: <HomeRoute />,
};

export default route;
